/**
 * Simplified route preloader using standard browser preloading
 * Browser and Vite handle chunking and caching efficiently
 */
export function RoutePreloader() {
  // No-op component - browser handles preloading via link prefetch
  // Vite's code splitting and browser caching are sufficient
  return null;
}

// Hook to preload a route on hover/focus (no-op for now)
export function useRoutePreloader() {
  const preloadRoute = (route: string) => {
    // No-op - rely on browser preloading and Vite's automatic code splitting
  };

  return { preloadRoute };
}